'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Filter.module.scss'
import { motion } from 'framer-motion'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Status, Region, Typology, Category } from '@/types/singles/category'
import { Image } from '@/types/common/ImageData'

interface DataProps {
    categories: Array<Category>;
    onFilterChange: (filters: { categories: string[] }) => void;
    filterCategories: Array<string>;
}

export default function JournalsFilterComponent({
    categories, 
    onFilterChange,
    filterCategories,
}: DataProps) {

    const [selectedFilters, setSelectedFilters] = useState<{ categories: string[] }>({
        categories: filterCategories,
    });
    const [openFilters, setOpenFilters] = useState(false);

    // En mobile el panel de filtros es un overlay a pantalla completa:
    // bloquea el scroll de la página mientras esté abierto (con cleanup al navegar)
    useEffect(() => {
        if (!openFilters || window.innerWidth >= 768) return;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [openFilters]);

    const handleCheckboxChange = (category: 'categories', value: string) => {
        setSelectedFilters(prevFilters => {
            let updatedCategory = prevFilters[category];
    
            if (value === "ALL") {
                // Si se selecciona "ALL", solo dejamos "ALL" en la categoría
                updatedCategory = ["ALL"];
            } else {
                // Si la opción ya estaba seleccionada, la quitamos
                if (updatedCategory.includes(value)) {
                    updatedCategory = updatedCategory.filter(item => item !== value);
                } else {
                    // Si "ALL" estaba seleccionado y se elige otra opción, lo eliminamos
                    updatedCategory = updatedCategory.filter(item => item !== "ALL");
                    updatedCategory.push(value);
                }
            }
    
            // Si la lista queda vacía, volvemos a poner "ALL"
            if (updatedCategory.length === 0) {
                updatedCategory = ["ALL"];
            }
    
            const newFilters = { ...prevFilters, [category]: updatedCategory };
            onFilterChange(newFilters);
            return newFilters;
        });
    };
    

    return (
        <div className={s.filterListPadding}>
        <div className={s.filterList}>
            <div className={s.filterHeader}>
                <div className={s.buttons}>
                    <button onClick={() => setOpenFilters(!openFilters)}>FILTERS 
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A"/>
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A" fillOpacity="0.2"/>
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A" fillOpacity="0.2"/>
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A" fillOpacity="0.2"/>
                        </svg>
                    </button>
                    {!selectedFilters.categories.includes('ALL') ?
                    <button onClick={() => {
                        onFilterChange({ categories: ['ALL'] });
                        setSelectedFilters({ categories: ['ALL'] });
                        
                    }}>
                        CLEAR FILTERS
                    </button> : undefined
                    }
                </div>
                
                <div className={s.listGrid}>
                </div>
            </div>
            {openFilters && (
            <motion.div className={`${s.filtering}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}

            >
                <div className={s.filterGroup}>
                    <h4>Categories</h4>
                    <div className={s.allFilters}>
                    <label className={s.checkboxLabel}>
                        <input
                            type="checkbox"
                            value="ALL"
                            checked={selectedFilters.categories.includes("ALL")}
                            onChange={() => handleCheckboxChange('categories', "ALL")}
                        />
                        <span className={s.checkmark}></span>
                        ALL
                    </label>
                    {categories.map((category, index) => (
                        <label key={index} className={s.checkboxLabel}>
                            <input
                                type="checkbox"
                                value={category.title}
                                checked={selectedFilters.categories.includes(category.title)}
                                onChange={() => handleCheckboxChange('categories', category.title)}
                            />
                            <span className={s.checkmark}></span>
                            {category.title}
                        </label>
                    ))}
                    </div>
                </div>

                <div className={s.applyFilters}>
                {(
                    (selectedFilters.categories.length > 0 && !selectedFilters.categories.includes("ALL"))
                ) ? (
                    <button onClick={() => setOpenFilters(false)} className={s.buttonMobileWith}>APPLY FILTERS</button>
                ) : (
                    <button onClick={() => setOpenFilters(false)} className={s.buttonMobile}>CLOSE</button>
                )}
                </div>
            </motion.div>
            )}
        </div>
        </div>
    )
}